module.exports = __webpack_public_path__ + "static/media/no-avatar.f0059b14.png";